<template>
  <div class="ProfileData">
    <div class="pb-10">
      <div class="headline pb-2">
        <v-icon class="fin-color-primary-dark--text">
          icon-your-data
        </v-icon>
        Meine Daten
      </div>
      <p> Hier kannst du deine wichtigsten Daten, Informationen und deine Interessen eingeben und bearbeiten.</p>
    </div>

    <fin-my-profile-block v-if="false">
      <template #title>
        <h4 style="position: relative"> Über mich
          <v-icon class="fin-color-primary-dark--text" style="position: absolute; right: 0"> icon-edit</v-icon>
        </h4>
      </template>
      <p>
        Being the savage's bowsman, that is, the person who pulled the bow-oar in his boat (the second one from
        forward), it was my cheerful duty to attend upon him while taking that hard-scrabble scramble upon the dead
        whale's back.
      </p>
    </fin-my-profile-block>

    <fin-my-profile-block>
      <template #title>
        <h4 style="position: relative"> Mein Archetype
          <v-icon class="fin-color-primary-dark--text" style="position: absolute; right: 0; bottom: 2px;"
                  @click="gotoFinProfiler">
            icon-edit
          </v-icon>
        </h4>
      </template>
      <p class="mb-0">{{ archetypeTitle }}</p>
    </fin-my-profile-block>

    <fin-my-profile-block>
      <template #title>
        <h4 style="position: relative"> Persönliche Daten
          <v-icon class="fin-color-primary-dark--text" style="position: absolute; right: 0; bottom: 2px;"
                  @click="editPersonDataDialog = true"> icon-edit
          </v-icon>
        </h4>
      </template>
      <div class="pb-6">
        <div style="font-style: italic;">
          Anrede und Name
        </div>
        <p v-if="fullSaluation" class="value mb-0">
          {{ fullSaluation }}
        </p>
        <p v-else>-</p>
      </div>

      <div class="pb-6">
        <div style="font-style: italic;">
          Adresse
        </div>
        <p v-if="profile.address">
          <span v-if="profile.address.street || profile.address.streetNo" style="display: block;">
            {{ profile.address.street }}
            &nbsp;
            {{ profile.address.streetNo }}
            <br/>
          </span>
          <span v-if="profile.address.zipCode || profile.address.city" style="display: block;">
            {{ profile.address.zipCode }}
            &nbsp;
            {{ profile.address.city }}
            <br/>
          </span>
          <span style="display: block;">{{ fullCountryName }}</span>
        </p>
        <p v-else>-</p>
      </div>
    </fin-my-profile-block>

    <fin-dialog v-model="editPersonDataDialog"
                :max-width="800">
      <template #title>
        Persönliche Daten bearbeiten
      </template>

      <v-form v-model="validPersonData"
              @submit.prevent="savePersonData">
        <v-container>
          <v-row style="max-width: 350px">
            <v-col>
              <v-select v-model="form.salutation"
                        :items="salutationItems"
                        hide-details
                        label="Anrede"/>
            </v-col>
            <v-col>
              <v-text-field v-model="form.title"
                            hide-details
                            label="Titel"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field v-model="form.firstname"
                            :rules="[ v => !!v || 'Vorname wird benötigt']"
                            hide-details="auto"
                            label="Vorname"/>
            </v-col>
            <v-col>
              <v-text-field v-model="form.lastname"
                            :rules="[ v => !!v || 'Nachname wird benötigt']"
                            hide-details="auto"
                            label="Nachname"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="9">
              <v-text-field v-model="form.address.street"
                            hide-details
                            label="Straße"/>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.address.streetNo"
                            hide-details
                            label="Nr"/>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field v-model="form.address.zipCode"
                            hide-details
                            label="PLZ"/>
            </v-col>
            <v-col cols="12" sm="5">
              <v-text-field v-model="form.address.city"
                            hide-details
                            label="Stadt"/>
            </v-col>
            <v-col cols="12" sm="4">
              <fin-country-selector v-model="form.address.country"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col align="right">
              <v-btn class="mr-2"
                     color="fin-color-primary-dark"
                     outlined
                     @click="editPersonDataDialog = false">
                Abbrechen
              </v-btn>
              <v-btn color="fin-color-primary-dark"
                     dark
                     tile
                     type="submit">
                Speichern
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <!-- TODO fin-error-msg :msg="error"/-->
        <!-- TODO date of birth and address -->
      </v-form>
    </fin-dialog>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import FinMyProfileBlock from "@/components/pages/profile/MyProfileBlock"
import FinCountrySelector from "@/components/common/CountrySelector"
import countries from "i18n-iso-countries"

countries.registerLocale(require("i18n-iso-countries/langs/en.json"))
countries.registerLocale(require("i18n-iso-countries/langs/de.json"))

export default {
  name: 'FinProfileData',
  components: {FinCountrySelector, FinMyProfileBlock},
  data() {
    return {
      editPersonDataDialog: false,
      validPersonData: true,// TODO
      salutationItems: [
        {
          text: '',
          value: ''
        },
        {
          text: 'Frau',
          value: 'FEMALE'
        },
        {
          text: 'Herr',
          value: 'MALE'
        }],
      form: {
        salutation: '',
        title: '',
        lastname: '',
        address: {
          street: '',
          streetNo: '',
          zipCode: '',
          city: '',
          country: {id: 'DE'}
        }
      },
    }
  },
  computed: {
    ...mapGetters('auth', ['profileArchetype', 'profile']),
    archetypeTitle() {
      return this.profileArchetype?.title || 'Der Anlegertyp wurde noch nicht definiert'
    },
    fullSaluation() {
      let salutation = ''

      if (this.profile.salutation) {
        if (this.profile.salutation === 'MALE') {
          salutation += 'Herr'
        } else if (this.profile.salutation === 'FEMALE') {
          salutation += 'Frau'
        }
      }

      if (this.profile.title) {
        salutation += ' ' + this.profile.title
      }

      if (this.profile.firstname) {
        salutation += ' ' + this.profile.firstname
      }

      if (this.profile.lastname) {
        salutation += ' ' + this.profile.lastname
      }

      return salutation
    },
    fullCountryName() {
      let name = ''

      if (this.profile.address && this.profile.address.country) {
        name = countries.getName(this.profile.address.country, 'de', {select: "official"})
      }

      return name
    }
  },
  methods: {
    ...mapActions('auth', ['updateUserPersonData']),
    gotoFinProfiler() {
      this.$router.push({name: 'finStrategy_profiler', params: {origin: 'myProfile'}})
    },
    async savePersonData() {
      const dateOfBirth = null
      const {title, salutation, firstname, lastname, address} = this.form

      // replace country object (from FinCountrySelector) with only the country id
      let country = address.country.id
      delete address.country
      address.country = country

      this.updateUserPersonData({title, salutation, firstname, lastname, dateOfBirth, address}).then(() => {
        this.$toasted.global.finToast({
          message: `Deine Änderungen wurden gespeichert.`,
          type: 'success'
        })
      }).catch(e => {
        console.error("failed to save user data changes", e)
        this.$toasted.global.finToast({
          message: 'Deine Änderungen konnten nicht gespeichert werden.',
          type: 'error'
        })
      })

      this.editPersonDataDialog = false
    }
  },
  watch: {
    editPersonDataDialog(val) {
      if (val) {
        this.form.salutation = this.profile?.salutation || ''
        this.form.title = this.profile?.title || ''
        this.form.firstname = this.profile?.firstname || ''
        this.form.lastname = this.profile?.lastname || ''
        this.form.address.street = this.profile?.address?.street || ''
        this.form.address.streetNo = this.profile?.address?.streetNo || ''
        this.form.address.zipCode = this.profile?.address?.zipCode || ''
        this.form.address.city = this.profile?.address?.city || ''
        const countryId = this.profile.address ? this.profile.address.country : 'DE'
        this.form.address.country = {id: countryId}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
